import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  inject,
  Injectable,
  Optional,
  PLATFORM_ID,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
  NativeDateAdapter,
} from '@angular/material/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CartDetailsComponent } from '@spartacus/cart/base/components';
import { CartConfigService } from '@spartacus/cart/base/core';
import { ActiveCartFacade, Cart, MultiCartFacade, SelectiveCartFacade } from '@spartacus/cart/base/root';
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront';
import { Subscription } from 'rxjs/internal/Subscription';
import { catchError, filter, map, take, takeUntil } from 'rxjs/operators';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';
import { KbCartService } from 'src/app/services/feature/cart/kb-cart.service';
import { CanNavigateCheckoutComponent } from './can-navigate-checkout/can-navigate-checkout.component';
import { DeleteCartConfirmationComponent } from './delete-cart-confirmation/delete-cart-confirmation.component';
import { CookieService } from 'src/app/customServices/cookie.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import moment from 'moment';
import { of, throwError } from 'rxjs';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';

const BASKET_PAGE_MESSAGE_REMOVE_KEY = 'common.basket_page_message_remove';
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  activeCartService = inject(ActiveCartFacade);
  dateformate = '';
  protected subscription1 = new Subscription();
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale?: string) {
    super(matDateLocale);
    this.subscription1.add(this.activeCartService.getActive().subscribe((res) => {
      this.dateformate = res?.dateFormat;
    }));
  }
  override parse(value: any, parseFormat?: any): Date | null {
    if (typeof value == 'number') {
      return new Date(value);
    }
    return value ? moment(value, this.dateformate?.toUpperCase()).toDate() : null;
  }
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return moment(date).format(this.dateformate?.toUpperCase());
    }
    return moment(date).format(this.dateformate?.toUpperCase());
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Component({
  selector: 'app-kb-cart-details',
  templateUrl: './kb-cart-details.component.html',
  styleUrls: ['./kb-cart-details.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
  standalone: false
})
export class KbCartDetailsComponent extends CartDetailsComponent {
  rdd: any;
  requesteddeliverydate = 'requesteddeliverydate';
  activeCart$: any;
  cartDetails: any;
  selectAllChecked: boolean = false;
  selectedEntryNbr: any = [];
  minDate = new Date();
  showOrderTypeError: boolean = false;
  keyValue: string;
  translatedString: string = '';
  isFormError: boolean = false;
  showTranslatedString: boolean = false;
  kbStatusMessage: any;
  disableDate: boolean = false;
  vorMessage: boolean = false;
  readonly: boolean = false;
  weekendsDatesFilter = (d: Date): boolean => {
    const day = d?.getDay();

    /* Prevent Saturday and Sunday for select. */
    return day !== 0 && day !== 6;
  };
  cartUpdateForm = new FormGroup({
    quantityControl: new FormControl(1),
  });
  isWeekendDate: any;
  isInvalid: any;
  isPastDate: any;
  @ViewChild('element') element: ElementRef;
  protected subscription = new Subscription();

  orderTypeSelected;
  fleetPrideGroup: any;
  deliveryDateForm: FormGroup;
  platformId = inject(PLATFORM_ID);
  isBulkRemove: boolean = false;
  currentB2bUnitSendToWebtrack !: string;
  constructor(
    activeCartService: ActiveCartFacade,
    selectiveCartService: SelectiveCartFacade,
    authService: AuthService,
    routingService: RoutingService,
    cartConfig: CartConfigService,
    private kbCartService: KbCartService,
    private cdr: ChangeDetectorRef,
    protected vcr: ViewContainerRef,
    protected launchDialogService: LaunchDialogService,
    private dialog: MatDialog,
    private globalMessageService: GlobalMessageService,
    private checkoutService: KbCheckOutService,
    private router: Router,
    private translationService: TranslationService,
    private cookieService: CookieService,
    private custIdService: CustomerIdService,
    private multiCartService: MultiCartFacade,
    private cartTrackingService: CartTrackingService,
    private viewPortScroller: ViewportScroller
  ) {
    super(activeCartService, selectiveCartService, authService, routingService, cartConfig);
    this.activeCartService.reloadActiveCart();
    this.getActiveCartDetails('init');

  }
  override ngOnInit() {
    this.subscription.add(this.custIdService.fleetPrideGroup$.subscribe((x) => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    }));
  }
  get deliveryDateControl(): FormControl {
    return this.deliveryDateForm.get('deliveryDate') as FormControl;
  }
  get f() {
    return this.cartUpdateForm.controls;
  }
  getActiveCartDetails(source?) {
    this.activeCart$ = this.activeCartService.getActive().pipe(
      map((item: any) => {
        this.disableDate = item.selectedOrderTypeCode === 'EMGY';
        this.currentB2bUnitSendToWebtrack = item.currentB2BUnit.uid;
        this.vorMessage = this.disableDate;
        if (this.disableDate) {
          this.deliveryDateForm = new FormGroup({
            deliveryDate: new FormControl(this.minDate),
          });
          this.readonly = true;
        } else {
          this.deliveryDateForm = new FormGroup({
            deliveryDate: new FormControl(''),
          })
          this.readonly = false;
        }
        return {
          ...item,
          defaultRDDFormatted: moment(item['defaultReqDeliveyDate'], item.dateFormat?.toUpperCase()).toDate(),
          showPOAText:
            item?.entries?.filter((ele) => !ele?.totalPrice || ele?.totalPrice?.formattedValue.indexOf('-') > -1)
              .length > 0,
          entries: item?.entries?.map((ele) => {
            return {
              ...ele,
              requestedDeliveryDateFormatted: moment(
                ele['requestedDeliveryDate'],
                item.dateFormat?.toUpperCase()
              ).toDate(),
              selected: false,
            };
          }),
        };
      })
    );
    this.subscription.add(this.activeCart$.subscribe((data) => {
      this.cartDetails = data.entries;
      this.kbStatusMessage = data?.kbStatusMessage;
      this.translatorOffer();
      if (source === 'init') {
        data.entries?.forEach((item, index) => {
          if (item['requestedDeliveryDate']) {
            const isWeekendDate = this.isWeekend(moment(item['requestedDeliveryDate'], data.dateFormat?.toUpperCase()).toDate());
            this.cartDetails[index].isWeekendDate = isWeekendDate;
          }
        });
        this.isFormError = this.cartDetails?.filter(item => item.isWeekendDate || item.isPastDate || item.isInvalid).length > 0
      }
    }));
  }

  getCartDetails(cartId) {
    this.isFormError = false;
    this.activeCart$ = this.kbCartService.getCartDetails(cartId).pipe(
      map((item: any) => {
        return {
          ...item,
          defaultRDDFormatted: moment(item['defaultReqDeliveyDate'], item.dateFormat?.toUpperCase()).toDate(),
          showPOAText:
            item?.entries?.filter((ele) => !ele?.totalPrice || ele?.totalPrice?.formattedValue.indexOf('-') > -1)
              .length > 0,
        };
      })
    );
    this.subscription.add(this.activeCart$.subscribe((item: any) => {
      this.cartDetails = item?.entries?.map((ele) =>
        Object.assign({}, ele, {
          requestedDeliveryDateFormatted: moment(ele['requestedDeliveryDate'], item.dateFormat?.toUpperCase()).toDate(),
          selected: false,
        })
      );
      item.entries?.forEach((ele, index) => {
        if (ele['requestedDeliveryDate']) {
          const isWeekendDate = this.isWeekend(moment(ele['requestedDeliveryDate'], item.dateFormat?.toUpperCase()).toDate());
          this.cartDetails[index].isWeekendDate = isWeekendDate;
        }
      });
      this.isFormError = this.cartDetails?.filter(item => item.isWeekendDate || item.isPastDate || item.isInvalid).length > 0

      this.cdr.detectChanges();
    }));
  }

  onOrderTypeChange(e, cartId) {
    if (e.target.value === 'EMGY') {
      this.disableDate = true;
      this.vorMessage = true;
      this.readonly = true;
      this.deliveryDateForm = new FormGroup({
        deliveryDate: new FormControl(this.minDate),
      });
    } else {
      this.vorMessage = false;
      this.disableDate = true;
      this.readonly = false;
      this.deliveryDateForm = new FormGroup({
        deliveryDate: new FormControl(''),
      })
    }
    this.subscription.add(this.kbCartService.updateOrderType(cartId, e.target.value).subscribe((item: any) => {
      this.getCartDetails(cartId);
    }));
  }

  productsWebtrackDeleteAll: any[] = []
  setSelect(ev, item, i) {
    this.cartDetails[i].selected = ev.target.checked;
    if (ev.target.checked) {
      this.selectedEntryNbr.push(item.entryNumber);
      this.productsWebtrackDeleteAll.push(item);
    } else {
      const i = this.selectedEntryNbr.indexOf(item.entryNumber);
      this.selectedEntryNbr.splice(i, 1);
      this.productsWebtrackDeleteAll.splice(i, 1);
    }
    this.selectAllChecked = this.cartDetails.filter((item) => !item.selected).length == 0;
    this.isBulkRemove = this.selectAllChecked;
  }

  selectAll(ev) {
    this.cartDetails.map((item: any) => (item.selected = ev.target.checked));
    this.selectedEntryNbr = [];
    if (ev.target.checked) {
      this.cartDetails.map((item) => {
        this.productsWebtrackDeleteAll.push(item);
        this.selectedEntryNbr.push(item.entryNumber);
      });
    }
    this.isBulkRemove = ev.target.checked;
  }

  deleteLineItem(item, cartId, product?, isQuantityZero?: boolean) {
    const entryNumber = `entryNumbers=${item.entryNumber}`;
    this.subscription.add(this.kbCartService.bulkRemove(cartId, entryNumber, false).subscribe((item) => {
      this.showPageMessage({ key: BASKET_PAGE_MESSAGE_REMOVE_KEY },
        GlobalMessageType.MSG_TYPE_INFO);

      // this.globalMessageService.add(
      //   { key: BASKET_PAGE_MESSAGE_REMOVE_KEY },
      //   GlobalMessageType.MSG_TYPE_INFO
      // );
      this.updateCartIdOnDeletion();
      this.WebTrekk_deleteAddToCart(product, cartId, isQuantityZero);
    }));
  }


  isWeekend(date: Date): boolean {
    if (date) {
      const dayOfWeek = date?.getDay();
      return dayOfWeek === 0 || dayOfWeek === 6; // 0 is Sunday, 6 is Saturday
    }
    return false;
  }
  private showPageMessage(message: any, type: any): void {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ASSISTIVE);
    this.globalMessageService.add(
      message,
      type
    );
  }
  rddValueChange(cartId, rdd, entryNbr, type?, cart?) {
    if (type === 'blur' && rdd.target?.value) {
      rdd = moment(rdd.target?.value, cart?.dateFormat?.toUpperCase()).toDate();
    }
    if (rdd) {
      this.isWeekendDate = this.isWeekend(rdd);
      this.isPastDate = rdd < new Date();
      this.isInvalid = isNaN(rdd);

      if (rdd && !this.isWeekendDate && !this.isPastDate && !this.isInvalid) {
        let formattedDate = '';

        formattedDate = moment(rdd).format(cart.dateFormat?.toUpperCase());

        this.subscription.add(this.kbCartService.updateDeliveyDate(cartId, formattedDate, entryNbr, formattedDate).subscribe((res: any) => {
          this.getCartDetails(cartId);
          this.showPageMessage({ key: res?.message },
            res.status === 'ERROR' ? GlobalMessageType.MSG_TYPE_ERROR : GlobalMessageType.MSG_TYPE_INFO);

          // this.globalMessageService.add(
          //   { key: res?.message },
          //   res.status === 'ERROR' ? GlobalMessageType.MSG_TYPE_ERROR : GlobalMessageType.MSG_TYPE_INFO
          // );
        }));
      }
    }
  }

  rddValueChangeLineItem(cartId, rdd, entryNbr, type?, i?, rdDate?) {
    this.deliveryDateControl.setValue('');
    if (type === 'blur' && rdd.target?.value) {
      rdd = moment(rdd.target?.value, rdDate?.dateFormat?.toUpperCase()).toDate();
    }
    if (rdd) {
      const isWeekendDate = this.isWeekend(rdd);
      const isPastDate = rdd < new Date(rdDate?.defaultReqDeliveyDate);
      const isInvalid = isNaN(rdd);

      this.cartDetails[i].isWeekendDate = isWeekendDate;
      this.cartDetails[i].isPastDate = isPastDate;
      this.cartDetails[i].isInvalid = isInvalid;

      if (isPastDate) {
        let formattedKey = '';
        this.subscription.add(this.translationService.translate('common.checkout_deliverydate_past').subscribe((key) => {
          formattedKey = key;
          if (key.includes('{0}')) {
            formattedKey = key.replace('{0}', rdDate.defaultReqDeliveyDate);
          }
        }))

        // this.globalMessageService.add(
        //   formattedKey,
        //   GlobalMessageType.MSG_TYPE_ERROR
        // );
        //         this.globalMessageService.add(
        //           formattedKey,
        //           GlobalMessageType.MSG_TYPE_ERROR
        //         );
        this.showPageMessage(formattedKey,
          GlobalMessageType.MSG_TYPE_ERROR);

      }
      this.isFormError = this.cartDetails.filter(item => item.isWeekendDate || item.isPastDate || item.isInvalid).length > 0

      if (rdd && !isWeekendDate && !isPastDate && !isInvalid) {
        let formattedDate = '';

        formattedDate = moment(rdd).format(rdDate.dateFormat?.toUpperCase());

        this.subscription.add(this.kbCartService.updateDeliveyDate(cartId, formattedDate, entryNbr, formattedDate).subscribe((res: any) => {
          this.getCartDetails(cartId);
          this.showPageMessage({ key: res?.message },
            res.status === 'ERROR' ? GlobalMessageType.MSG_TYPE_ERROR : GlobalMessageType.MSG_TYPE_INFO);
          // this.globalMessageService.add(
          //   { key: res?.message },
          //   res.status === 'ERROR' ? GlobalMessageType.MSG_TYPE_ERROR : GlobalMessageType.MSG_TYPE_INFO
          // );
        }));
      }
    }
  }

  quantityUpdate(qty, entryNbr, item, cartId) {
    if (qty + '' == item.formattedQuantity) {
      return;
    }
    if (qty != null) {
      if (qty == 0) {
        this.deleteLineItem(item, cartId, item, true);
      } else {
        this.activeCartService.updateEntry(entryNbr, qty);
        this.cartTrackingService.trackQuantityChange(qty, item, cartId, this.currentB2bUnitSendToWebtrack);
        this.updateCartIdOnDeletion();
        this.showPageMessage({ key: 'common.basket_page_message_update' },
          GlobalMessageType.MSG_TYPE_INFO);

        // this.globalMessageService.add(
        //   { key: 'common.basket_page_message_update' },
        //   GlobalMessageType.MSG_TYPE_INFO
        // );
      }
    } else {
      this.showPageMessage({ key: 'common.basket_error_quantity_notNull' },
        GlobalMessageType.MSG_TYPE_ERROR);

      // this.globalMessageService.add(
      //   { key: 'common.basket_error_quantity_notNull' },
      //   GlobalMessageType.MSG_TYPE_ERROR
      // );
      this.updateCartIdOnDeletion();
    }
  }

  openDialog(cart: any) {
    this.subscription.add(this.kbCartService.getSavedCartDetails(cart.code).subscribe((data) => {
      const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.SAVED_CART, this.element, this.vcr, {
        cart,
        layoutOption: 'save',
        data,
      });

      if (dialog) {
        this.subscription.add(dialog.pipe(take(1)).subscribe());
      }
    }));
  }

  deleteAll(cartId) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    const dialogRef = this.dialog.open(DeleteCartConfirmationComponent, dialogConfig);
    this.subscription.add(dialogRef.afterClosed().subscribe((data) => {
      if (data == true) {
        let entryNumber = '';
        this.selectedEntryNbr.forEach((element) => {
          if (entryNumber == '') {
            entryNumber = `entryNumbers=${element}`;
          } else {
            entryNumber += `&entryNumbers=${element}`;
          }
        });
        this.subscription.add(this.kbCartService
          .bulkRemove(cartId, entryNumber, this.isBulkRemove)
          .pipe(
            catchError((error) => {
              if (error.status === 0) {
                if (isPlatformBrowser(this.platformId)) {
                  window.location.reload();
                  // this.globalMessageService.add(
                  //   { key: BASKET_PAGE_MESSAGE_REMOVE_KEY },
                  //   GlobalMessageType.MSG_TYPE_INFO
                  // );
                  this.showPageMessage({ key: BASKET_PAGE_MESSAGE_REMOVE_KEY },
                    GlobalMessageType.MSG_TYPE_INFO);
                }
              }
              return throwError(error);
            })
          )
          .subscribe((item) => {
            // this.globalMessageService.add(
            //   { key: BASKET_PAGE_MESSAGE_REMOVE_KEY },
            //   GlobalMessageType.MSG_TYPE_INFO
            // );
            this.WebTrekk_deleteAllAddToCart(this.productsWebtrackDeleteAll, cartId);
            this.showPageMessage({ key: BASKET_PAGE_MESSAGE_REMOVE_KEY },
              GlobalMessageType.MSG_TYPE_INFO);
            this.selectedEntryNbr = [];
            this.productsWebtrackDeleteAll = [];
            this.selectAllChecked = false;
            this.isBulkRemove = false;
            this.updateCartIdOnDeletion();

          }));
      }
    }));
  }
  updateCartIdOnDeletion() {
    this.subscription.add(this.custIdService.setSpecificCustomerId().subscribe((res: any) => {
      const cartId = res?.userWSDTO.cartId;
      if (cartId) {
        this.multiCartService.reloadCart(cartId, { active: true });
        this.getCartDetails(cartId);
      }
    }));
  }
  canNavigateCheckout(cartId, selectedOrderType) {
    this.cookieService.setItemSessionStorage('userInwhichStep', 0);
    if (!selectedOrderType) {
      this.showOrderTypeError = true;
      this.viewPortScroller.scrollToPosition([0, 100]);
      this.cdr.detectChanges();
    } else {
      this.showOrderTypeError = false;
      this.subscription.add(this.checkoutService.canNavigateToCheckOut(false, cartId).subscribe((x) => {
        if (x) {
          //checking merege require or not
          if (x?.['isMergeEntries'] == false) {
            this.cartTrackingService.trackCheckout(this.cartDetails, cartId, this.currentB2bUnitSendToWebtrack);
            this.router.navigate(['multiStepCheckoutSummary']);
            this.activeCartService.reloadActiveCart();
          } else if (x?.['isMergeEntries'] == true) {
            this.dialog.open(CanNavigateCheckoutComponent);
          }
          //checking error or success
          if (x?.['status'] == 'SUCCESS') {
            this.cartTrackingService.trackCheckout(this.cartDetails, cartId, this.currentB2bUnitSendToWebtrack);
            this.activeCartService.reloadActiveCart();
            this.router.navigate(['multiStepCheckoutSummary']);
          } else if (x?.['status'] == 'ERROR') {
            this.translationService.translate(x?.['message']).subscribe((key) => {
              if (key.includes('{0}')) {
                key = key.replace('{0}', x?.['errorValue1']);
              }
              if (key.includes('{1}')) {
                key = key.replace('{1}', x?.['errorValue2']);
              }
              this.keyValue = key;
              this.showPageMessage(key, GlobalMessageType.MSG_TYPE_ERROR);
            });

          }
        } else {
          this.dialog.open(CanNavigateCheckoutComponent);
        }
      }));
    }
  }
  hitGlobalMessage(keyValue) {
    this.showPageMessage(keyValue, GlobalMessageType.MSG_TYPE_ERROR);
  }
  translatorOffer() {
    const isStocOrder = this.kbStatusMessage ? true : false;
    if (isStocOrder) {
      this.showTranslatedString = true;
      this.subscription.add(this.translationService.translate(this.kbStatusMessage?.message).subscribe((res) => {
        this.translatedString = res
          .replace('{0}', this.kbStatusMessage?.errorDoubleValue1.toFixed(2))
          .replaceAll('{1}', this.kbStatusMessage?.errorValue1)
          .replace('{2}', this.kbStatusMessage?.errorDoubleValue2.toFixed(2));
      }));
    }
  }
  hidePromotions() {
    this.showTranslatedString = false;
  }

  WebTrekk_deleteAddToCart(product, cartId, isQuantityZero?: boolean) {
    if (isQuantityZero) {
      this.cartTrackingService.trackQuantityZeroChange(product, cartId, 'CART_PAGE', this.currentB2bUnitSendToWebtrack);
    }
    else {
      this.cartTrackingService.deleteFromCart(product, cartId, 'CART_PAGE', this.currentB2bUnitSendToWebtrack);
    }

  }

  WebTrekk_deleteAllAddToCart(products, cartId) {
    // getting called From deleteAll -> All product deletion
    this.cartTrackingService.deleteFromCartAllProducts(products, cartId, 'CART_PAGE', this.currentB2bUnitSendToWebtrack);
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    if (this.subscription && this.subscription instanceof Subscription) {
      this.subscription.unsubscribe();
    }
  }

}
